import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { CartService, CartItem } from '../../services/cart.service';
import { ApiUrl } from '../../shared/models/apiurl.models';
import { TokenStore } from '../../services/token-store';
import { CreditCardComponent } from '../create-adv/select-route/credit-card/credit-card.component';

@Component({
    selector: 'app-cart',
    templateUrl: './cart.component.html',
    styleUrls: ['./cart.component.scss'],
    standalone: false
})
export class CartComponent implements OnInit, OnDestroy {
  items: CartItem[] = [];
  checkoutLoading = false;
  checkoutError: string | null = null;
  private sub!: Subscription;

  constructor(
    public cart: CartService,
    private http: HttpClient,
    private apiKey: ApiUrl,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.sub = this.cart.items$.subscribe(items => this.items = items);
  }

  ngOnDestroy(): void { this.sub?.unsubscribe(); }

  get total(): number { return this.cart.total; }

  formatPrice(n: number): string {
    return '₪' + n.toLocaleString('he-IL', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  checkout(): void {
    if (this.items.length === 0 || this.checkoutLoading) return;

    // /auth/login does not exist - open the login modal on this page.
    if (!TokenStore.isLoggedIn()) {
      window.location.href = '/cart?loginOpenForm=true';
      return;
    }

    this.checkoutLoading = true;
    this.checkoutError = null;

    // Bearer is added by AppInterceptor. This used to send 'Token ' + the
    // is_logged_in marker, i.e. the literal header 'Token 1'.
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    const payload = {
      items: this.items.map(i => ({ product_id: i.id, quantity: i.qty }))
    };

    this.http.post<{ session_id: string; session_url: string; order_ids: number[]; total: number }>(
      this.apiKey.initiateCartCheckout(),
      payload,
      { headers }
    ).pipe(catchError(err => {
      this.checkoutLoading = false;
      this.checkoutError = err?.error?.error || 'שגיאה ביצירת הזמנה';
      return of(null);
    })).subscribe(res => {
      this.checkoutLoading = false;
      if (!res) return;

      this.dialog.open(CreditCardComponent, {
        data: {
          adsRoute: {
            id:    0,
            title: 'עגלת קניות',
            price: res.total,
            lifeSpan: null,
            image: '',
            level: null,
          },
          adsId:            null,
          isSubscription:   false,
          isMarketPurchase: false,
          isCartPurchase:   true,
          orderIds:         res.order_ids,
          sessionId:        res.session_id,
        },
        width:      '760px',
        direction:  'rtl',
        panelClass: 'market-payment-dialog',
      });
    });
  }
}
